module.exports = __webpack_public_path__ + "assets/b88.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b88.png
// module id = 680
// module chunks = 0